<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Profile</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>

          <v-card-text class="#f4f5f7">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" class="ml-7">
                  <input
                    type="file"
                    name="profile_pic"
                    @change="changeFile($event)"
                    ref="profile_pic"
                    hidden
                  />
                  <v-badge bordered bottom overlap offset-x="20" offset-y="20">
                    <template v-slot:badge>
                      <v-icon
                        small
                        dark
                        @click="openFileExplorer"
                        class="edit-icon"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <v-avatar
                      size="120"
                      v-if="user.logo_url != null"
                      class="cursor-pointer"
                    >
                      <img
                        :src="API_BASE_URL + '/uploads/' + user.logo_url"
                        :alt="user.logo_url"
                        v-if="!previewImage"
                      />
                      <img
                        :src="previewImage"
                        :alt="user.logo_url"
                        v-if="previewImage"
                      />
                    </v-avatar>
                    <v-avatar
                      v-if="user.logo_url == null"
                      color="secondary"
                      class="white--text cursor-pointer imagePreviewWrapper"
                      :style="{ 'background-image': `url(${previewImage})` }"
                      size="120"
                    >
                    </v-avatar>
                    <v-avatar
                      v-if="user.logo_url == null"
                      color="secondary"
                      class="white--text cursor-pointer"
                      size="120"
                    >
                      <span class="font-30">{{
                        user.name ? user.name.charAt(0) : ""
                      }}</span>
                    </v-avatar>
                  </v-badge>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.name"
                    name="name"
                    prepend-icon="mdi-account-outline"
                    label="Name"
                    v-validate="'required'"
                    :error="
                      errors.first('name') != null ||
                      serverSideErrors.name != null
                    "
                    :error-messages="
                      errors.first('name') || serverSideErrors.name
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="user.address"
                    name="address"
                    rows="2"
                    prepend-icon="mdi-google-maps"
                    label="Address"
                    v-validate="'required'"
                    :error="
                      errors.first('address') != null ||
                      serverSideErrors.address != null
                    "
                    :error-messages="
                      errors.first('address') || serverSideErrors.address
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.contact_person_name"
                    name="contact person name"
                    prepend-icon="mdi-contacts"
                    label="Contact Person Name"
                    v-validate="'required'"
                    :error="
                      errors.first('contact person name') != null ||
                      serverSideErrors.contact_person_name != null
                    "
                    :error-messages="
                      errors.first('contact person name') ||
                      serverSideErrors.contact_person_name
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.current_balance"
                    name="name"
                    prepend-icon="mdi-currency-inr"
                    label="Current balance"
                    v-validate="'required'"
                    :error="
                      errors.first('current_balance') != null ||
                      serverSideErrors.current_balance != null
                    "
                    :error-messages="
                      errors.first('current_balance') ||
                      serverSideErrors.current_balance
                    "
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
               
                <v-col cols="12" xs="12" sm="12" md="6" class="d-flex">
                  <v-icon left> mdi-phone-outline </v-icon>
                  <vue-country-code
                  label="Block"
                    @onSelect="onSelect"
                    class="custom-country-code-select"
                    :defaultCountry="flag"
                  
                  >
                  </vue-country-code>
                  <v-text-field
                    v-model="user.contact_person_number"
                    name="number"
                    label="Contact Person Number"
                    v-validate="'required'"
                    :error="
                      errors.first('number') != null ||
                      serverSideErrors.contact_person_number != null
                    "
                    :error-messages="
                      errors.first('number') ||
                      serverSideErrors.contact_person_number
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.contact_person_email"
                    name="email"
                    prepend-icon="mdi-email-outline"
                    label="Contact Person Email"
                    v-validate="'required'"
                    :error="
                      errors.first('email') != null ||
                      serverSideErrors.contact_person_email != null
                    "
                    :error-messages="
                      errors.first('email') ||
                      serverSideErrors.contact_person_email
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <div id="app">
              <GoogleMap />
            </div>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="updateProfile"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import GoogleMap from "../societyadmin/GoogleMap.vue";
import { mapMutations } from "vuex";
export default {
  components: {
    GoogleMap,
  },
  data() {
    return {
      loading: false,
      user: {
        name: "",
        address: "",
        contact_person_name: "",
        contact_person_number: "",
        contact_person_email: "",
        logo_url: "",
        current_balance: "",
        country_code: "",
        countryIso: "",
      },
      serverSideErrors: {},
      profile_pic: {},
      previewImage: null,
    };
  },
  created() {
    // this.user = JSON.parse(localStorage.getItem("user"));
    this.getSocietyDetail();
    this.flag = JSON.parse(localStorage.getItem("flag"));
    if (!localStorage.getItem("pageRefreshed")) {
      window.location.reload();
      localStorage.setItem("pageRefreshed", "true");
    } else {
      localStorage.removeItem("pageRefreshed");
    }
  },

  methods: {
    getSocietyDetail() {
      let _self = this;
      _self.$axios
        .get("/societyadmin/societyProfile")
        .then((response) => {
          let data = response.data;


if (data.status) {
  _self.user = data.society;
           

            _self.user.countryIso = data.society.countryIso;
            console.log(_self.user.countryIso);
            localStorage.setItem(
              "flag",
              JSON.stringify(_self.user.countryIso)
            );

          

          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    onSelect(event) {
      this.user.country_code = "+" + event.dialCode;
      this.user.countryIso = event.iso2;
    },
    ...mapMutations("alert", ["setAlert"]),
    updateProfile() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("name", this.user.name);
          console.log(this.user.name)
          formData.append("address", this.user.address);
          formData.append("contact_person_name", this.user.contact_person_name);
          formData.append("current_balance", this.user.current_balance);
          formData.append(
            "contact_person_number",
            this.user.contact_person_number
          );
          formData.append(
            "contact_person_email",
            this.user.contact_person_email
          );
          formData.append("country_code",this.user.country_code);
          formData.append("countryIso", this.user.countryIso);
          formData.append("logo_url", this.profile_pic);

          _self.$axios
            .post("/societyadmin/societyProfile", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.user = data.user;
                // console.log(this.user);
                this.profile_pic = {};

                data.user.role = "societyadmin";
                data.user.token = this.user.token;
                localStorage.setItem("user", JSON.stringify(data.user));

                // let user = localStorage.getItem("user");
                // console.log(user.countryIso)
                if (data.user.logo_url) {
                  _self.$emit("changeProfilePic");
                }

                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    openFileExplorer() {
      this.$refs.profile_pic.click();
    },
    changeFile(e) {
      this.profile_pic = e.target.files[0];
      let input = this.$refs.profile_pic;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
  },
};
</script>

<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
.custom-country-code-select {
  width: 59px;
  height: 40px;
  margin-top: 3px;
  border: none;
  background-color: inherit;
  box-shadow: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 0;
}
.vue-country-select:focus-within {
  box-shadow: none !important;
}
</style>
